export default __webpack_public_path__ + "static/media/31.19a68e25.png";